import React, { useState } from "react";
import toast from "react-hot-toast";
import { createAdmin } from "../../services/adminService";

const CreateAdminForm = ({ member, onClose = () => {} }) => {
  const { memberId, memberName, memberEmail } = member;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const { status, message } = await createAdmin(
      { name: memberName, email: memberEmail || email, memberId },
      password
    );
    if (status === 200) {
      toast.success(message || "Admin created");
      onClose();
    } else {
      toast.error("Sorry, something went wrong!");
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h3>Make admin</h3>
        <form onSubmit={handleSubmit}>
          <div className="frm-field">
            <label>Name</label>
            <input type="text" value={memberName} disabled />
          </div>
          <div className="frm-field">
            <label htmlFor="adminEmail">Email address</label>
            <input
              id="adminEmail"
              type="email"
              value={memberEmail || email}
              disabled={!!memberEmail}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
            />
          </div>
          <div className="frm-field">
            <label htmlFor="adminPassword">Password</label>
            <input
              id="adminPassword"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Set a password for the new admin"
            />
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={submitting}>{submitting ? "Creating…" : "Create admin"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateAdminForm;
